import clsx from "clsx";
import { MdWifiOff } from "react-icons/md";

import useDarkMode from "../../hooks/useDarkMode";

import { ICON_SIZES } from "../../helpers/constants";
import useMobile from "src/hooks/useMobile";

const OfflineNotificationBar: React.FC = () => {
  const { isEnabled: isDarkMode } = useDarkMode();
  const { isMobile } = useMobile();

  return (
    <div
      className={clsx([
        "inline-flex",
        "p-2",
        "md:pl-0",
        "fixed",
        "left-auto md:left-1/2",
        "md:-translate-x-1/2",
        "right-2 md:right-auto",
        "bottom-[108px] md:bottom-[50px]",
        "bg-red-500/95 text-white",
        "z-[100]",
        "flex-col",
        "items-center",
        "justify-center",
        "p-1",
        "rounded-md",
        "shadow-sm",
      ])}
    >
      <div
        className={clsx([
          "flex",
          "flex-row",
          "gap-2",
          "items-center",
          "md:pl-2",
        ])}
      >
        <MdWifiOff
          size={isMobile ? ICON_SIZES.SM : ICON_SIZES.MD}
          className="shrink-0"
        />
        <div
          className={clsx(["text-sm", "font-normal", "flex-shrink-0", "flex"])}
        >
          Parece que no tienes conexión
        </div>
      </div>
    </div>
  );
};

export default OfflineNotificationBar;
